/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import {
  getFormatedDate,
  getFormatedType,
  getFormatedMoneyIn,
  getFormatedMoneyOut,
} from '@helpers/andesUtils';

import moment from 'moment';
import { useAndes, useAuth } from '@hooks';
import _ from 'lodash';
import { TYPE_MOVEMENT_AUTHORIZATION } from '@constants/transactions';
import { isCountryColombia } from 'constants/regions';
import { NewTable, RowZ, ColZ, LayoutZ } from '../Table';

const ImageDots = styled.img`
  display: none;
  width: 16px;
  margin-left: 4px;

  @media (min-width: 600px) {
    display: inline;
  }
`;

const AlignItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const OperationTable = ({
  dataHeader,
  dataBody,
  properity = [],
  limit = Infinity,
  setIdToShow,
  shouldGetFutureTransactions = true,
  setTransactionIdToShow,
}) => {
  const { t } = useTranslation();
  const { getBanks } = useAndes(undefined, shouldGetFutureTransactions);
  const { isAllowed } = useAuth();
  const banks = getBanks();

  const setBankDescription = (foDate) => {
    const bank = banks.find(
      (b) =>
        b.hasOwnProperty('created_at') &&
        b.hasOwnProperty('updated_at') &&
        ((b.enabled && moment(foDate).isAfter(b.created_at)) ||
          (!b.enabled && moment(foDate).isBetween(b.created_at, b.updated_at)))
    );
    if (!bank) return t('lastMovements.fondsOut');
    const accountNumber = bank?.account_data?.account_number;
    const lastFourDigits = accountNumber && accountNumber.substring(accountNumber.length - 4);
    const accountBank = bank?.bank_data?.finantial_institution_name;
    const accountBankCap = _.startCase(_.camelCase(accountBank));
    return `${t('lastMovements.fondsOutTo')}${accountBankCap}${t(
      'lastMovements.points'
    )}${lastFourDigits}`;
  };

  const getFondsOutByAuthorization = ({ type, event_date_utc, soft_descriptor, entry_mode }) => {
    switch (type) {
      case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN:
        return t('lastMovements.payOrder');
      case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS:
        return t('lastMovements.advancementsIn')
      case TYPE_MOVEMENT_AUTHORIZATION.CARGO_SALDO:
        return t('lastMovements.deferredTransfer');
      case TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_OUT:
        return entry_mode
          ? t('lastMovements.creditLineCollection')
          : isAllowed('FOUNDS_BANK_VALIDATION')
          ? setBankDescription(event_date_utc)
          : t('lastMovements.fondsOut');
      case TYPE_MOVEMENT_AUTHORIZATION.INGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.EGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_EGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_INGRESO_DE_SALDO:
      case TYPE_MOVEMENT_AUTHORIZATION.CANCEL_CARGO_SALDO:
        return t('lastMovements.regularizationAdjust');
      case TYPE_MOVEMENT_AUTHORIZATION.PAGO_DE_CUOTA_DE_CREDITO:
        return t('lastMovements.creditInstallmentPayment');
      case TYPE_MOVEMENT_AUTHORIZATION.CANCELACION_DE_PAGO:
        return t('lastMovements.creditInstallmentRefund');

      default:
        return soft_descriptor;
    }
  };

  return (
    <LayoutZ>
      <NewTable>
        {dataHeader && (
          <RowZ header>
            {dataHeader?.map((el, k) => (
              <ColZ key={`key-header-${k}`} header RightHeader {...properity[k]}>
                {el}
              </ColZ>
            ))}
          </RowZ>
        )}

        {dataBody &&
          dataBody.map(
            (el, i) =>
              i < limit && (
                <RowZ
                  key={i}
                  onClick={() => {
                    setIdToShow(el.authorization);
                    setTransactionIdToShow(el.transaction?.id);
                  }}
                  data-testid={`table-row-${i}`}
                >
                  <ColZ type="title" order="3" flex data-testid={`row-${i}-col-fondsOut`}>
                    {getFondsOutByAuthorization(el.authorization)}
                  </ColZ>
                  <ColZ
                    order="4"
                    type="title"
                    textalign="right"
                    align="right"
                    data-testid={`row-${i}-col-amount`}
                  >
                    <AlignItems>
                      {el.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN ||
                      el.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS ||
                      el.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.INGRESO_DE_SALDO ||
                      el.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.CANCELACION_DE_PAGO ||
                      el.authorization.type ===
                        TYPE_MOVEMENT_AUTHORIZATION.CANCEL_EGRESO_DE_SALDO ||
                      el.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.CANCEL_CARGO_SALDO
                        ? getFormatedMoneyIn(el.authorization.amount)
                        : getFormatedMoneyOut(el.authorization.amount)}
                      <ImageDots src="ic_menu_dots.svg" alt="menu" />
                    </AlignItems>
                  </ColZ>

                  <ColZ order="1" data-testid={`row-${i}-col-authorization`}>
                    {el.authorization.id}
                  </ColZ>
                  <ColZ order="0" textalign="right" date data-testid={`row-${i}-col-event-date`}>
                    {getFormatedDate(el.authorization.event_date)}
                  </ColZ>
                  <ColZ
                    order="2"
                    textalign="right"
                    align="left"
                    nodata
                    data-testid={`row-${i}-col-type`}
                  >
                    {isCountryColombia && getFormatedType(el.authorization.type) === 'Ingreso'
                      ? 'Entrada'
                      : isCountryColombia && getFormatedType(el.authorization.type) === 'Egreso'
                      ? 'Salida'
                      : getFormatedType(el.authorization.type)}
                  </ColZ>
                </RowZ>
              )
          )}
      </NewTable>
    </LayoutZ>
  );
};

export default OperationTable;
